<template>
    <div class="p-text-center mf-footer">
        <a href="https://mouseflow.com/">&copy; {{ year }} Mouseflow</a> -
        <a
            target="_blank"
            href="https://mouseflow.com/legal/mouseflow-partner-terms-and-conditions/"
            >{{ $t('general.termsAndConditions') }}</a
        >
    </div>
</template>

<script>
export default {
    setup() {
        const year = new Date().getFullYear();
        return {
            year
        };
    }
};
</script>

<style lang="scss" scoped>
.mf-footer {
    color: $mf-harbor-stone;
    margin-top: 45px;

    a {
        color: $mf-harbor-stone;
        text-decoration: none;
    }
}
</style>
